import React from 'react';
import { Box, Typography, Alert, AlertTitle } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';


const EmiNoteBox = () => {
  return (
    <Box sx={{ my: 2 }}>
      <Alert
        icon={<InfoIcon />}
        severity="info"
        sx={{
          border: '1px solid #fdd835',
          backgroundColor: '#fffde7',
          color: '#000',
        }}
      >
        <strong>Note!</strong>
        The EMI Calculator is provided for informational purposes only. The results generated are estimates based on the input values provided and may not reflect the exact amounts payable.
      </Alert>
    </Box>
  );
};

export default EmiNoteBox;
